import request from 'api/requestUtils'

interface ConvertCurrencyRequest {
  total: number
  baseCurrencyCode: string
  targetCurrencyCode: string
}

interface ConvertCurrencyResponse {
  result: {
    total: number
    convertedTotal: number
    baseCurrencyCode: string
    targetCurrencyCode: string
  }
}

/** Converts an amount between currencies at svc-fx's v2 rates. */
export async function convertCurrency(
  total: number,
  baseCurrencyCode: string,
  targetCurrencyCode: string,
): Promise<number> {
  const { result } = await request.post<ConvertCurrencyResponse, ConvertCurrencyRequest>(
    '/api/fx/v2/convert-currency',
    { total, baseCurrencyCode, targetCurrencyCode },
    { excludeBrand: true },
  )
  return result.convertedTotal
}
